const _agentByRoleId = [  
  { value: '3', text: 'Agent2' }  
];
const _lead = {
  "data":[{ "leads":
    {
      "id": 1,
      "name": "Nawaf Abo Sief Fawaz",
      "phone": null,
      "phone_2": "333444444444444",
      "workplace": null,
      "status": "Open",
      "location": null,
      "is_prelead": 1,
      "occupation": null,
      "gender": "Male",
      "broker_id": 2,
      "date_of_birth": null,
      "agent_id": 3,
      "is_qualified": null,
      "comment": null,
      "lead_source": 3,
      "email": "sayed@fabrica.com.eg",
      "job_title": null,
      "budget_from": '3cr',
      "budget_to": '5cr',
      "address": null,
      "national_num": "N_ID 123456",
      "passport_num": null,
      "is_client": null,
      "national_url": null,
      "passport_url": null,
      "created_at": "2018-01-03 16:24:28",
      "updated_at": "2018-01-06 14:12:46",
      "deleted_at": null,
      "agent": {
            "id": 3,
            "name": "Agent",
            "email": "agent@equity.com.eg",
            "phone": null,
            "other_phone": null,
            "role": "Agent",
            "job_title": null,
            "image_id": 1,
            "broker_id": null,
            "is_active": null,
            "created_at": "2018-01-03 15:50:44",
            "updated_at": "2018-01-03 15:50:44"
        }
    },
    "activities":{
        "January, 2018": [
            {
                "monthyear": "January, 2018",
                "id": 3,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-06 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "January, 2018",
                "id": 2,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 8,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 9,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-05 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "December, 2017": [
            {
                "monthyear": "December, 2017",
                "id": 4,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 10,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 5,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 11,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "November, 2017": [
            {
                "monthyear": "November, 2017",
                "id": 6,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "November, 2017",
                "id": 12,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            }
        ]
    }
},
   { "leads":
    {
      "id": 2,
      "name": "Halvour",
      "phone": null,
      "phone_2": "333444444444444",
      "workplace": null,
      "status": "Open",
      "location": null,
      "is_prelead": 1,
      "occupation": null,
      "gender": "Male",
      "broker_id": null,
      "date_of_birth": null,
      "agent_id": 3,
      "is_qualified": null,
      "comment": null,
      "lead_source": null,
      "email": "sayed@fabrica.com.eg",
      "job_title": null,
      "budget_from": '3cr',
      "budget_to": '5cr',
      "address": null,
      "national_num": "N_ID 123456",
      "passport_num": null,
      "is_client": null,
      "national_url": null,
      "passport_url": null,
      "created_at": "2018-01-03 16:24:28",
      "updated_at": "2018-01-06 14:12:46",
      "deleted_at": null,
      "agent": {
            "id": 3,
            "name": "Agent",
            "email": "agent@equity.com.eg",
            "phone": null,
            "other_phone": null,
            "role": "Agent",
            "job_title": null,
            "image_id": 1,
            "broker_id": null,
            "is_active": null,
            "created_at": "2018-01-03 15:50:44",
            "updated_at": "2018-01-03 15:50:44"
        }
    },
    "activities":{
        "January, 2018": [
            {
                "monthyear": "January, 2018",
                "id": 3,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-06 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "January, 2018",
                "id": 2,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 8,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 9,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-05 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "December, 2017": [
            {
                "monthyear": "December, 2017",
                "id": 4,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 10,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 5,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 11,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "November, 2017": [
            {
                "monthyear": "November, 2017",
                "id": 6,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "November, 2017",
                "id": 12,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            }
        ]
    }
},
   { "leads":
    {
      "id": 3,
      "name": "Tom",
      "phone": null,
      "phone_2": "333444444444444",
      "workplace": null,
      "status": "Open",
      "location": null,
      "is_prelead": 0,
      "occupation": null,
      "gender": "Male",
      "broker_id": null,
      "date_of_birth": null,
      "agent_id": 3,
      "is_qualified": null,
      "comment": null,
      "lead_source": null,
      "email": "sayed@fabrica.com.eg",
      "job_title": null,
      "budget_from": '3cr',
      "budget_to": '5cr',
      "address": null,
      "national_num": "N_ID 123456",
      "passport_num": null,
      "is_client": null,
      "national_url": null,
      "passport_url": null,
      "created_at": "2018-01-03 16:24:28",
      "updated_at": "2018-01-06 14:12:46",
      "deleted_at": null,
      "agent": {
            "id": 3,
            "name": "Agent",
            "email": "agent@equity.com.eg",
            "phone": null,
            "other_phone": null,
            "role": "Agent",
            "job_title": null,
            "image_id": 1,
            "broker_id": null,
            "is_active": null,
            "created_at": "2018-01-03 15:50:44",
            "updated_at": "2018-01-03 15:50:44"
        }
    },
    "activities":{
        "January, 2018": [
            {
                "monthyear": "January, 2018",
                "id": 3,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-06 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "January, 2018",
                "id": 2,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 8,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 9,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-05 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "December, 2017": [
            {
                "monthyear": "December, 2017",
                "id": 4,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 10,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 5,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 11,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "November, 2017": [
            {
                "monthyear": "November, 2017",
                "id": 6,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "November, 2017",
                "id": 12,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            }
        ]
    }
},
   { "leads":
    {
      "id": 4,
      "name": "Chin",
      "phone": null,
      "phone_2": "333444444444444",
      "workplace": null,
      "status": "Inprogress",
      "location": null,
      "is_prelead": 0,
      "occupation": null,
      "gender": "Male",
      "broker_id": null,
      "date_of_birth": null,
      "agent_id": 3,
      "is_qualified": null,
      "comment": null,
      "lead_source": null,
      "email": "sayed@fabrica.com.eg",
      "job_title": null,
      "budget_from": '3cr',
      "budget_to": '5cr',
      "address": null,
      "national_num": "N_ID 123456",
      "passport_num": null,
      "is_client": null,
      "national_url": null,
      "passport_url": null,
      "created_at": "2018-01-03 16:24:28",
      "updated_at": "2018-01-06 14:12:46",
      "deleted_at": null,
      "agent": {
            "id": 3,
            "name": "Agent",
            "email": "agent@equity.com.eg",
            "phone": null,
            "other_phone": null,
            "role": "Agent",
            "job_title": null,
            "image_id": 1,
            "broker_id": null,
            "is_active": null,
            "created_at": "2018-01-03 15:50:44",
            "updated_at": "2018-01-03 15:50:44"
        }
    },
    "activities":{
        "January, 2018": [
            {
                "monthyear": "January, 2018",
                "id": 3,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-06 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "January, 2018",
                "id": 2,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 8,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 9,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-05 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "December, 2017": [
            {
                "monthyear": "December, 2017",
                "id": 4,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 10,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 5,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 11,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "November, 2017": [
            {
                "monthyear": "November, 2017",
                "id": 6,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "November, 2017",
                "id": 12,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            }
        ]
    }
},
   { "leads":
    {
      "id": 5,
      "name": "Rehman",
      "phone": null,
      "phone_2": "333444444444444",
      "workplace": null,
      "status": "Disqualified",
      "location": null,
      "is_prelead": 0,
      "occupation": null,
      "gender": "Male",
      "broker_id": null,
      "date_of_birth": null,
      "agent_id": 3,
      "is_qualified": null,
      "comment": null,
      "lead_source": null,
      "email": "sayed@fabrica.com.eg",
      "job_title": null,
      "budget_from": '3cr',
      "budget_to": '5cr',
      "address": null,
      "national_num": "N_ID 123456",
      "passport_num": null,
      "is_client": null,
      "national_url": null,
      "passport_url": null,
      "created_at": "2018-01-03 16:24:28",
      "updated_at": "2018-01-06 14:12:46",
      "deleted_at": null,
      "agent": {
            "id": 3,
            "name": "Agent",
            "email": "agent@equity.com.eg",
            "phone": null,
            "other_phone": null,
            "role": "Agent",
            "job_title": null,
            "image_id": 1,
            "broker_id": null,
            "is_active": null,
            "created_at": "2018-01-03 15:50:44",
            "updated_at": "2018-01-03 15:50:44"
        }
    },
    "activities":{
        "January, 2018": [
            {
                "monthyear": "January, 2018",
                "id": 3,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-06 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "January, 2018",
                "id": 2,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 8,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 9,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-05 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "December, 2017": [
            {
                "monthyear": "December, 2017",
                "id": 4,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 10,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 5,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 11,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "November, 2017": [
            {
                "monthyear": "November, 2017",
                "id": 6,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "November, 2017",
                "id": 12,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            }
        ]
    }
},
   { "leads":
    {
      "id": 6,
      "name": "Pervej",
      "phone": null,
      "phone_2": "333444444444444",
      "workplace": null,
      "status": "Closed",
      "location": null,
      "is_prelead": 0,
      "occupation": null,
      "gender": "Male",
      "broker_id": null,
      "date_of_birth": null,
      "agent_id": 3,
      "is_qualified": null,
      "comment": null,
      "lead_source": null,
      "email": "sayed@fabrica.com.eg",
      "job_title": null,
      "budget_from": '3cr',
      "budget_to": '5cr',
      "address": null,
      "national_num": "N_ID 123456",
      "passport_num": null,
      "is_client": null,
      "national_url": null,
      "passport_url": null,
      "created_at": "2018-01-03 16:24:28",
      "updated_at": "2018-01-06 14:12:46",
      "deleted_at": null,
      "agent": {
            "id": 3,
            "name": "Agent",
            "email": "agent@equity.com.eg",
            "phone": null,
            "other_phone": null,
            "role": "Agent",
            "job_title": null,
            "image_id": 1,
            "broker_id": null,
            "is_active": null,
            "created_at": "2018-01-03 15:50:44",
            "updated_at": "2018-01-03 15:50:44"
        }
    },
    "activities":{
        "January, 2018": [
            {
                "monthyear": "January, 2018",
                "id": 3,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-06 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "January, 2018",
                "id": 2,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 8,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 9,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-05 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "December, 2017": [
            {
                "monthyear": "December, 2017",
                "id": 4,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 10,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 5,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 11,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "November, 2017": [
            {
                "monthyear": "November, 2017",
                "id": 6,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "November, 2017",
                "id": 12,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            }
        ]
    }
},
   { "leads":
    {
      "id": 7,
      "name": "Kaif",
      "phone": null,
      "phone_2": "333444444444444",
      "workplace": null,
      "status": "Inprogress",
      "location": null,
      "is_prelead": 0,
      "occupation": null,
      "gender": "Male",
      "broker_id": null,
      "date_of_birth": null,
      "agent_id": 3,
      "is_qualified": null,
      "comment": null,
      "lead_source": null,
      "email": "sayed@fabrica.com.eg",
      "job_title": null,
      "budget_from": '3cr',
      "budget_to": '5cr',
      "address": null,
      "national_num": "N_ID 123456",
      "passport_num": null,
      "is_client": null,
      "national_url": null,
      "passport_url": null,
      "created_at": "2018-01-03 16:24:28",
      "updated_at": "2018-01-06 14:12:46",
      "deleted_at": null,
      "agent": {
            "id": 3,
            "name": "Agent",
            "email": "agent@equity.com.eg",
            "phone": null,
            "other_phone": null,
            "role": "Agent",
            "job_title": null,
            "image_id": 1,
            "broker_id": null,
            "is_active": null,
            "created_at": "2018-01-03 15:50:44",
            "updated_at": "2018-01-03 15:50:44"
        }
    },
    "activities":{
        "January, 2018": [
            {
                "monthyear": "January, 2018",
                "id": 3,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-06 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "January, 2018",
                "id": 2,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 8,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "next step",
                "type": "Status",
                "lead_status": "Follow Up",
                "created_at": "2018-01-06 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "January, 2018",
                "id": 9,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2018-01-05 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "December, 2017": [
            {
                "monthyear": "December, 2017",
                "id": 4,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 10,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-27 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 5,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            },
            {
                "monthyear": "December, 2017",
                "id": 11,
                "user_id": 1,
                "lead_id": 1,
                "title": "new activity",
                "details": "hello world",
                "type": "Activity",
                "lead_status": null,
                "created_at": "2017-12-13 16:19:14",
                "updated_at": "2018-01-06 16:19:14"
            }
        ],
        "November, 2017": [
            {
                "monthyear": "November, 2017",
                "id": 6,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            },
            {
                "monthyear": "November, 2017",
                "id": 12,
                "user_id": 1,
                "lead_id": 1,
                "title": "Status Changed",
                "details": "test test",
                "type": "Status",
                "lead_status": "Closed",
                "created_at": "2017-11-01 12:48:52",
                "updated_at": "2018-01-06 12:48:52"
            }
        ]
    }
}
  ]}
const _leadList = {
    "current_page": 1,
    "data": [
        {
            "id": 1,
            "name": "Nawaf Abo Sief Fawaz",
            "phone": "8273427647",
            "phone_2": null,
            "workplace": null,
            "status": "Open",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": null,
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": 3,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "sayed@fabrica.com.eg",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": null,
            "national_num": null,
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-04 11:30:41",
            "updated_at": "2018-01-04 11:30:41",
            "deleted_at": null,
            "agent": {
                "id": 3,
                "name": "Agent",
                "email": "agent@equity.com.eg",
                "phone": null,
                "other_phone": null,
                "role": "Agent",
                "job_title": null,
                "image_id": 1,
                "broker_id": null,
                "is_active": null,
                "created_at": "2018-01-03 15:50:44",
                "updated_at": "2018-01-03 15:50:44"
            }
        },
        {
            "id": 2,
            "name": "Halvour",
            "phone": "98756555",
            "phone_2": null,
            "workplace": null,
            "status": "Open",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": null,
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": null,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "test2@fabrica.com",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": "Cairo, EGYPT",
            "national_num": null,
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-03 16:24:29",
            "updated_at": "2018-01-03 16:24:29",
            "deleted_at": null,
            "agent": null,            
        },
        {
            "id": 3,
            "name": "Tom",
            "phone": null,
            "phone_2": "333444444444444",
            "workplace": null,
            "status": "Open",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": "Male",
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": 4,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "sayed@fabrica.com.eg",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": null,
            "national_num": "N_ID 123456",
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-03 16:24:28",
            "updated_at": "2018-01-06 14:12:46",
            "deleted_at": null,
            "agent": {
                "id": 3,
                "name": "Agent",
                "email": "agent@equity.com.eg",
                "phone": null,
                "other_phone": null,
                "role": "Agent",
                "job_title": null,
                "image_id": 1,
                "broker_id": null,
                "is_active": null,
                "created_at": "2018-01-03 15:50:44",
                "updated_at": "2018-01-03 15:50:44"
            }
        },
        {
            "id": 4,
            "name": "Chin",
            "phone": null,
            "phone_2": "333444444444444",
            "workplace": null,
            "status": "Inprogress",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": "Male",
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": 2,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "sayed@fabrica.com.eg",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": null,
            "national_num": "N_ID 123456",
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-03 16:24:28",
            "updated_at": "2018-01-06 14:12:46",
            "deleted_at": null,
            "agent": {
                "id": 3,
                "name": "Agent",
                "email": "agent@equity.com.eg",
                "phone": null,
                "other_phone": null,
                "role": "Agent",
                "job_title": null,
                "image_id": 1,
                "broker_id": null,
                "is_active": null,
                "created_at": "2018-01-03 15:50:44",
                "updated_at": "2018-01-03 15:50:44"
            }
        },
        {
            "id": 5,
            "name": "Rehman",
            "phone": null,
            "phone_2": "333444444444444",
            "workplace": null,
            "status": "Disqualified",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": "Male",
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": 3,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "sayed@fabrica.com.eg",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": null,
            "national_num": "N_ID 123456",
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-03 16:24:28",
            "updated_at": "2018-01-06 14:12:46",
            "deleted_at": null,
            "agent": {
                "id": 3,
                "name": "Agent",
                "email": "agent@equity.com.eg",
                "phone": null,
                "other_phone": null,
                "role": "Agent",
                "job_title": null,
                "image_id": 1,
                "broker_id": null,
                "is_active": null,
                "created_at": "2018-01-03 15:50:44",
                "updated_at": "2018-01-03 15:50:44"
            }
        },
        {
            "id": 6,
            "name": "Pervej",
            "phone": null,
            "phone_2": "333444444444444",
            "workplace": null,
            "status": "Closed",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": "Male",
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": 2,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "sayed@fabrica.com.eg",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": null,
            "national_num": "N_ID 123456",
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-03 16:24:28",
            "updated_at": "2018-01-06 14:12:46",
            "deleted_at": null,
            "agent": {
                "id": 3,
                "name": "Agent",
                "email": "agent@equity.com.eg",
                "phone": null,
                "other_phone": null,
                "role": "Agent",
                "job_title": null,
                "image_id": 1,
                "broker_id": null,
                "is_active": null,
                "created_at": "2018-01-03 15:50:44",
                "updated_at": "2018-01-03 15:50:44"
            }
        },
        {
            "id": 7,
            "name": "Kaif",
            "phone": null,
            "phone_2": "333444444444444",
            "workplace": null,
            "status": "Inprogress",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": "Male",
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": 3,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "sayed@fabrica.com.eg",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": null,
            "national_num": "N_ID 123456",
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-03 16:24:28",
            "updated_at": "2018-01-06 14:12:46",
            "deleted_at": null,
            "agent": {
                "id": 3,
                "name": "Agent",
                "email": "agent@equity.com.eg",
                "phone": null,
                "other_phone": null,
                "role": "Agent",
                "job_title": null,
                "image_id": 1,
                "broker_id": null,
                "is_active": null,
                "created_at": "2018-01-03 15:50:44",
                "updated_at": "2018-01-03 15:50:44"
            }
        }
    ],
    "first_page_url": "http://127.0.0.1:8000/api/leads?page%5Bnumber%5D=1",
    "from": 1,
    "last_page": 1,
    "last_page_url": "http://127.0.0.1:8000/api/leads?page%5Bnumber%5D=1",
    "next_page_url": null,
    "path": "http://127.0.0.1:8000/api/leads",
    "per_page": 30,
    "prev_page_url": null,
    "to": 3,
    "total": 3
}
const _nextleadList = {
    "current_page": 1,
    "data": [
        {
            "id": 1,
            "name": "Nawaf Abo Sief Fawaz",
            "phone": "8273427647",
            "phone_2": null,
            "workplace": null,
            "status": "Open",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": null,
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": 3,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "sayed@fabrica.com.eg",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": null,
            "national_num": null,
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-04 11:30:41",
            "updated_at": "2018-01-04 11:30:41",
            "deleted_at": null,
            "agent": {
                "id": 3,
                "name": "Agent",
                "email": "agent@equity.com.eg",
                "phone": null,
                "other_phone": null,
                "role": "Agent",
                "job_title": null,
                "image_id": 1,
                "broker_id": null,
                "is_active": null,
                "created_at": "2018-01-03 15:50:44",
                "updated_at": "2018-01-03 15:50:44"
            }
        },
        {
            "id": 2,
            "name": "Halvour",
            "phone": "98756555",
            "phone_2": null,
            "workplace": null,
            "status": "Open",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": null,
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": null,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "test2@fabrica.com",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": "Cairo, EGYPT",
            "national_num": null,
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-03 16:24:29",
            "updated_at": "2018-01-03 16:24:29",
            "deleted_at": null,
            "agent": null,            
        },
        {
            "id": 3,
            "name": "Tom",
            "phone": null,
            "phone_2": "333444444444444",
            "workplace": null,
            "status": "Open",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": "Male",
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": 4,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "sayed@fabrica.com.eg",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": null,
            "national_num": "N_ID 123456",
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-03 16:24:28",
            "updated_at": "2018-01-06 14:12:46",
            "deleted_at": null,
            "agent": {
                "id": 3,
                "name": "Agent",
                "email": "agent@equity.com.eg",
                "phone": null,
                "other_phone": null,
                "role": "Agent",
                "job_title": null,
                "image_id": 1,
                "broker_id": null,
                "is_active": null,
                "created_at": "2018-01-03 15:50:44",
                "updated_at": "2018-01-03 15:50:44"
            }
        },
         {
            "id": 4,
            "name": "Chin",
            "phone": null,
            "phone_2": "333444444444444",
            "workplace": null,
            "status": "Inprogress",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": "Male",
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": 2,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "sayed@fabrica.com.eg",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": null,
            "national_num": "N_ID 123456",
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-03 16:24:28",
            "updated_at": "2018-01-06 14:12:46",
            "deleted_at": null,
            "agent": {
                "id": 3,
                "name": "Agent",
                "email": "agent@equity.com.eg",
                "phone": null,
                "other_phone": null,
                "role": "Agent",
                "job_title": null,
                "image_id": 1,
                "broker_id": null,
                "is_active": null,
                "created_at": "2018-01-03 15:50:44",
                "updated_at": "2018-01-03 15:50:44"
            }
        },
         {
            "id": 5,
            "name": "Rehman",
            "phone": null,
            "phone_2": "333444444444444",
            "workplace": null,
            "status": "Disqualified",
            "location": null,
            "is_prelead": 1,
            "occupation": null,
            "gender": "Male",
            "broker_id": null,
            "date_of_birth": null,
            "agent_id": 3,
            "is_qualified": null,
            "comment": null,
            "lead_source": null,
            "email": "sayed@fabrica.com.eg",
            "job_title": null,
            "budget_from": null,
            "budget_to": null,
            "address": null,
            "national_num": "N_ID 123456",
            "passport_num": null,
            "is_client": null,
            "national_url": null,
            "passport_url": null,
            "created_at": "2018-01-03 16:24:28",
            "updated_at": "2018-01-06 14:12:46",
            "deleted_at": null,
            "agent": {
                "id": 3,
                "name": "Agent",
                "email": "agent@equity.com.eg",
                "phone": null,
                "other_phone": null,
                "role": "Agent",
                "job_title": null,
                "image_id": 1,
                "broker_id": null,
                "is_active": null,
                "created_at": "2018-01-03 15:50:44",
                "updated_at": "2018-01-03 15:50:44"
            }
        }],
       
    "first_page_url": "http://127.0.0.1:8000/api/leads?page%5Bnumber%5D=1",
    "from": 1,
    "last_page": 1,
    "last_page_url": "http://127.0.0.1:8000/api/leads?page%5Bnumber%5D=1",
    "next_page_url": null,
    "path": "http://127.0.0.1:8000/api/leads",
    "per_page": 30,
    "prev_page_url": null,
    "to": 3,
    "total": 3
}
const _roles = [
  {roleId:1,roleType:'Manager'},
  {roleId:2,roleType:'Admin'},
  {roleId:3,roleType:'Agent'}
];
const _documnetType = [
  {text:'Passport'},
  {text:'National Id Number'}
];
const _leadDocuments = [
  {'id':1, 'leadId':'1', 'documentType':'passport','documentNumber':'433454556','lastEdit':'Feb12,2017','documentName':'Scan.png'},
  
];
export class MockApi  { 

getLeads () {
  return _leadList;
}

getRole () {
  return _roles
}
getAgentsByRoleId () {
  return _agentByRoleId;
}
getDocumentTypes () {
  return _documnetType;
}
getLeadDocumnets () {
  return _leadDocuments;
}
getLeadByLeadId () {
  return _lead;
}
getNextLeads () {  
  return _nextleadList;
}
getLeadsByStatus (staus) {  
  return _leadList.data.find(item => item.status === status );
}
}


// WEBPACK FOOTER //
// ./src/app/dtos/mockapi.ts